var map = {
	"./1.gif": "a8fe",
	"./10.gif": "58d4",
	"./11.gif": "f9a4",
	"./2.gif": "458a",
	"./3.gif": "74a9",
	"./4.gif": "e2fe",
	"./5.gif": "dd17",
	"./6.gif": "a21b",
	"./7.gif": "21a6",
	"./8.gif": "5c05",
	"./9.gif": "6eec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "979d";